import { SET_JETON, CALCULER_GRAPHE1, CALCULER_GRAPHE2, SET_AFFICHER_FENETRE_EXPORT, SET_ALERTE, SET_CHECKTHEME, SET_AFFICHER_LEGENDE, SET_AFFICHER_LISTE_COUCHES, SET_LISTE_DES_COUCHES, SET_CERCLE_PROPORTIONNEL, SET_LISTE_THEMATIQUES, SET_FOND_DE_CARTE, SET_TERRITOIRE, SET_THEME1, SET_THEME2, SET_THEME3, SET_LISTE_CERCLES_PROPORTIONNEL, CALCULER } from "./actionTypes";

const initialState = {
  listethematiques: [],
  fonddecarte: "Fond gris",
  territoire: "BDR",
  maillage: "",
  afficherlistecouches: true,
  afficherlegende: true,
  checkThemes: {
    checkTheme1: true,
    checkTheme2: true,
    checkTheme3: true,
    checkTheme1Theme2: true,
    checkTheme1Theme3: true,
    checkTheme2Theme3: true,
    checkTheme1Theme2Theme3: true
  },
  listecouches: [],
  alertetexte: "",
  alertetype: "",
  afficherfenetreexport: false,
  graphe1: "",
  graphe2: "",
  jeton: "",
  maille:{ol_uid:0},
};

export default function appReducer(state = initialState, action) {
  //console.log(action)
  switch (action.type) {

    case SET_JETON: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case SET_AFFICHER_FENETRE_EXPORT: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case SET_ALERTE: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case SET_CHECKTHEME: {
      return {
        ...state,
        checkThemes: action.payload,
      };
    }
    case SET_AFFICHER_LISTE_COUCHES: {
      return {
        ...state,
        afficherlistecouches: action.payload,
      };
    }
    case SET_AFFICHER_LEGENDE: {
      return {
        ...state,
        afficherlegende: action.payload,
      };
    }
    case SET_LISTE_THEMATIQUES: {
      return {
        ...state,
        listethematiques: action.payload.listethematiques,
      };
    }
    case SET_LISTE_DES_COUCHES: {
      return {
        ...state,
        listecouches: action.payload.liste,
      };
    }
    case SET_LISTE_CERCLES_PROPORTIONNEL: {
      return {
        ...state,
        listecerclesproportionnel: action.payload.liste,
      };
    }
    case SET_CERCLE_PROPORTIONNEL: {
      return {
        ...state,
        cercleproportionnel: action.payload.cercleproportionnel,
      };

    }
    case SET_FOND_DE_CARTE: {
      return {
        ...state,
        fonddecarte: action.payload.fonddecarte,
      };

    }
    case SET_TERRITOIRE: {
      return {
        ...state,
        territoire: action.payload.territoire,
      };

    }

    case SET_THEME1: {
      return {
        ...state,
        theme1: action.payload.theme,
      };

    }

    case SET_THEME2: {
      return {
        ...state,
        theme2: action.payload.theme,
      };

    }

    case SET_THEME3: {
      return {
        ...state,
        theme3: action.payload.theme,
      };
    }

    case CALCULER: {
      return {
        ...state,
        maille: action.payload.maille,
      };
    }

    case CALCULER_GRAPHE1: {
      return {
        ...state,
        graphe1: action.payload.options,
      };
    }

    case CALCULER_GRAPHE2: {
      return {
        ...state,
        graphe2: action.payload.options,
      };
    }

    default:
      return state;
  }
}
